import { Breadcrumbs } from '@veneer/core';
import getBreadCrumbsRoutes from '../../utils/maps/breadCrumbsRoutes';


function BackButton(props: any) {
    return (
        <Breadcrumbs
            aria-label="Breadcrumb with two levels"
            items={getBreadCrumbsRoutes(props) || []}
        />
    );
}


export default BackButton;